import styled from '@emotion/styled';

import { ReactComponent as TrashIcon } from '../../../images/trash.svg';
import { ReactComponent as PlusIcon } from '../../../images/Plus.svg';
import { ReactComponent as PlugIcon } from '../../../images/plug.svg';

import { Link } from 'react-router-dom';



export const BagsBox = styled.div`
border-radius: 16px;
padding: 16px;
padding-bottom: 0;
padding-right: 16зч;
width: 100%;
height: 100%;
background: var(--colors-grey-50);
  /* @media screen and (min-width: 375px) {
    width: 375px;
    margin: 0 auto;
  }

  @media screen and (min-width: 768px) {
    width: 768px;
  }

  @media screen and (min-width: 1440px) {
    width: 1440px;
    display: flex;
    max-height: 100vh;
  } */
`;

export const HorizontalBox = styled.div`
display: flex;
align-items: center;
gap: 16px;
margin-top: 8px;
@media (max-width: 689px) {
  gap: 12px;
&.mobb{
  flex-direction: column;
}
  
  } 
`;

export const BagsTitleBox = styled.div`
  display: flex;
align-items: center;
justify-content: space-between;
border-bottom: 1px solid var(--colors-grey-200);
padding: 0px 0px 12px 0px;
width:100%;

margin-bottom: 16px;
`;

export const BagsBodyBox = styled.div`
width: 100%;
height: fit-content;
padding: 0 0px 16px 0;
min-height: fit-content;
`;

export const ChoiceCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
export const BagsTitle = styled.h2`
display: flex;
align-items: center;
gap:8px;
font-family: var(--font-family);
font-weight: 600;
font-size: 20px;
line-height: 135%;
color: var(--colors-grey-800);
`;
export const BagsStatus = styled.span`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-25);
background-color: ${props => props.statusCol};
border-radius: 360px;
padding: 4px 12px;
`;


export const IconTrash = styled(TrashIcon)`
  width: 24px;
  height: 24px;
  cursor:pointer
 

`;


export const IconPlus = styled(PlusIcon)`
  width: 18px;
  height: 18px;
stroke:var(--colors-grey-25);

`;





export const BagsNoText = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-500);
`;


export const ButtonWrap = styled.div`

display: flex;
align-items: center;
gap:8px;
`;

export const ConfirmButton = styled.button`

font-family: var(--font-family);
font-weight: 600;
font-size: 12px;
line-height: 137%;
text-align: center;
color:${props => props.out ? 'var(--colors-primary-600)' : ' var(--colors-grey-25)'};
gap:8px;
display: flex;
align-items: center;
background: ${props => props.out ? 'none' : 'var(--colors-primary-600)'};
border: ${props => props.out? '1px solid var(--colors-primary-600)' : 'none'};
border-radius: 360px;
padding: 8px 24px;

cursor: pointer;
  @media (max-width: 844px) {
border-radius: 8px;
padding: 8px;
width: 32px;
height: 32px;}
`;

export const IconPlug = styled(PlugIcon)`
  width: 16px;
  height: 16px;
  cursor: pointer;
  stroke:var(--colors-grey-25);
`;


export const ChangeButton = styled(Link)`
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-25);
gap:8px;
display: flex;
align-items: center;

background:var(--colors-primary-600);
border-radius: 360px;
padding: 8px 24px;
cursor: pointer;
  @media (max-width: 844px) {
border-radius: 8px;
padding: 8px;
width: 32px;
height: 32px;
  
  } 
`;







export const SubFieldWrapper = styled.div`
border-radius: 16px;
background: var(--colors-grey-25);
padding: 16px;
min-height: 100%;
height: fit-content;
width: 100%;

`;

export const ShopsList = styled.ul`
display: flex;
flex-direction: column;

align-items: stretch;
`;
export const ShopItem = styled.li`
display: flex;
border-bottom: 1px solid var(--colors-grey-100);
padding:  12px 0px;
gap:16px;
align-items: center;
justify-content: space-between;
&:first-of-type{
  padding-top: 0;
}
&:last-of-type{
  padding-bottom: 0;
  border-bottom: none;
}
`;

export const Texts = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
width: 100%;
color: var(--colors-grey-500);
box-sizing: border-box;
display:inline-block;
margin-bottom: 4px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
`;
export const BoxA = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: row;
width: 117px;
height: 32px;
`;

export const Texts1 = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
width: 100%;
min-width: 175px;
color: var(--colors-grey-500);
box-sizing: border-box;
display:inline-block;

overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
`;

export const Titles = styled.p`
font-family: var(--font-family);
font-weight: 500;
width: 100%;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-900);
box-sizing: border-box;
display:flex;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
align-items: center;
&+&{
  margin-top: 8px;
}
`;

export const ShopBox = styled.div`
display: flex;
width: calc(100% - 48px);
flex-direction: column;
align-items: flex-start;
`;